import {
  beRcsGetScheduledSendings,
  beRcsSendCancelSchedule,
  beRcsSendDeleteSending,
  beRcsSendEnqueueRetry,
  beRcsSendPatchSchedule,
  beRcsSendUpdateScheduleState
} from 'Api/beRcsSend'
import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

export async function getScheduledSendings(params) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beRcsGetScheduledSendings(idList, params)

  return result
}

export async function enqueueRetry(idQueuing) {
  const result = beRcsSendEnqueueRetry(idQueuing)

  return result
}

export async function patchSchedule(idSchedule, params) {
  const result = beRcsSendPatchSchedule(idSchedule, params)

  return result
}

export async function cancelSchedule(idSchedule) {
  const result = beRcsSendCancelSchedule(idSchedule)

  return result
}

export async function deleteSending(idSending) {
  const result = beRcsSendDeleteSending(idSending)

  return result
}

export async function updateScheduleState(idSchedule, params) {
  const result = beRcsSendUpdateScheduleState(idSchedule, params)

  return result
}
